var initPolylineMap = function (marker, backControl, roadStartKm, startKm, stopKm) {
  var _latitude = sessionStorage.Lat && sessionStorage.Lat != 'undefined' ? sessionStorage.Lat.replace(',', '.') : 0;
  var _longitude = sessionStorage.Lng && sessionStorage.Lng != 'undefined' ? sessionStorage.Lng.replace(',', '.') : 0;
    var init_lat = _latitude > 0 ? _latitude : AppConfig.defaultMapCenter[0];
    var init_lng = _longitude > 0 ? _longitude : AppConfig.defaultMapCenter[1];
    let roadStart = roadStartKm ? roadStartKm * 1e3 : 0;

  L.Icon.Default.imagePath = AppConfig.imagePath;
  var grayscale = L.tileLayer(MapSettings.urlFormat, { attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' });

  var mymap = L.map('marker-map', {
    center: [init_lat, init_lng],
    zoom: AppConfig.defaultMapZoom,
    maxBounds: L.latLngBounds(AppConfig.defaultMapBounds[0], AppConfig.defaultMapBounds[1]),
    minZoom: AppConfig.defaultMapMinZoom,
    zoomReverse: true,
    layers: [grayscale]
  });

  var roadPoints = [[]];

  var result = {
    startPoint: null,
    endPoint: null,
    startKm: roadStart,
    endKm: roadStart,
    points: [],
    startMarker: null,
    endMarker: null,
    polyline: null,
    startEdgeIndex: 0,
    endEdgeIndex: 0,
    startEdgeSection: 0,
    endEdgeSection: 0,
    map: mymap
  };

  if (roadCurrentCoordinates.length && roadCurrentCoordinates[0].length > 1) {
      roadPoints = MapHelper.convertToLatLng(roadCurrentCoordinates);

    var roadsLine = new L.Polyline(roadPoints, {
      color: 'blue',
      weight: 5,
      opacity: 0.5,
      smoothFactor: 1
    });
    roadsLine.addTo(mymap);

      //Добавляем, что есть.
      if (startKm * 1e3 < roadStart)
          startKm = roadStart / 1e3;
      var startPoint = null;
      if (startKm != null && !isNaN(startKm)) {
          var startPosition = MapHelper.findPositionByDistance(startKm * 1e3 - roadStart, roadPoints);
          startPoint = startPosition.point;
          initPoint(startPosition, startKm * 1e3);
      }
      if (!startPoint) {
          startPoint = L.latLng(parseFloat($(roadCurrentCoordinates).first()[0][0].Lat), parseFloat($(roadCurrentCoordinates).first()[0][0].Lng));
          addPointIfCan(startPoint);
      }

      if (stopKm * 1e3 < roadStart)
          stopKm = roadStart / 1e3;
      var stopPoint = null;
      if (stopKm != null && !isNaN(stopKm)) {
          var stopPosition = MapHelper.findPositionByDistance(stopKm * 1e3 - roadStart, roadPoints);
          stopPoint = stopPosition.point;
          initPoint(stopPosition, stopKm * 1e3);
      }
      if (!stopPoint) {
          stopPoint = L.latLng(parseFloat($(roadCurrentCoordinates).first()[0][0].Lat), parseFloat($(roadCurrentCoordinates).first()[0][0].Lng));
      }
      addPointIfCan(stopPoint);

    roadsLine.on('click', function (e) {

      var point = e.latlng;

      addPointIfCan(point);
    });

    backControl.on('click', function () {

      if (result.endPoint != null) {
        result.endPoint = null;
        result.endKm = roadStart;
      } else if (result.startPoint != null) {
        result.startPoint = null;
        result.startKm = roadStart;
      } else {
        return;
      }

      update();
    });
  }

    function clear() {
        if (result.polyline != null) {
            mymap.removeLayer(result.polyline);
            result.polyline = null;
        }

        if (result.startPoint == null && result.startMarker != null) {
            mymap.removeLayer(result.startMarker);
            result.startMarker = null;
        }

        if (result.endPoint == null && result.endMarker != null) {
            mymap.removeLayer(result.endMarker);
            result.endMarker = null;
        }

        result.points = [];
    }

    function normalizeStartEnd() {
        if (result.startKm > result.endKm) {
            //меняем местами
            var tempKm = result.startKm;
            result.startKm = result.endKm;
            result.endKm = tempKm;

            var tempPoint = result.startPoint;
            result.startPoint = result.endPoint;
            result.endPoint = tempPoint;

            var tempMarker = result.startMarker;
            result.startMarker = result.endMarker;
            result.endMarker = tempMarker;

            var tempIndex = result.startEdgeIndex;
            result.startEdgeIndex = result.endEdgeIndex;
            result.endEdgeIndex = tempIndex;

            var tempSection = result.startEdgeSection;
            result.startEdgeSection = result.endEdgeSection;
            result.endEdgeSection = tempSection;
        }
    }

    function update() {

        if (result.startPoint != null && result.startMarker == null) {
            result.startMarker = L.marker(result.startPoint, { title: 'Начало (' + (result.startKm / 1000).toFixed(2) + ' км) - ' + result.startPoint }).bindPopup('Начало (' + (result.startKm / 1000).toFixed(2) + ' км) - ' + result.startPoint).addTo(mymap);
        }
        if (result.endPoint != null && result.endMarker == null) {
            result.endMarker = L.marker(result.endPoint, { title: 'Конец (' + (result.endKm / 1000).toFixed(2) + ' км) - ' + result.endPoint }).bindPopup('Конец (' + (result.endKm / 1000).toFixed(2) + ' км) - ' + result.endPoint).addTo(mymap);
        }

        if (result.startPoint == null || result.endPoint == null) {
            clear();
            return;
        }

        normalizeStartEnd();
        //TODO:Использовать метод MapHelper.getCoordinatesByStartEnd
        if (result.startEdgeSection !== result.endEdgeSection) {
            result.points.push([]);
            result.points[result.points.length - 1].push(result.startPoint);
            for (let i = result.startEdgeIndex; i < roadPoints[result.startEdgeSection].length; i++) {
                result.points[result.points.length - 1].push(roadPoints[result.startEdgeSection][i]);
            }
            for (let j = result.startEdgeSection + 1; j < result.endEdgeSection; j++) {
                result.points.push([]);
                for (let i = 0; i < roadPoints[j].length; i++) {
                    result.points[result.points.length - 1].push(roadPoints[j][i]);
                }
            }
            result.points.push([]);
            for (let i = 0; i < result.endEdgeIndex; i++) {
                result.points[result.points.length - 1].push(roadPoints[result.endEdgeSection][i]);
            }
            result.points[result.points.length - 1].push(result.endPoint);
        } else {
            result.points.push(result.startPoint);
            for (let i = result.startEdgeIndex; i < result.endEdgeIndex; i++) {
                result.points.push(roadPoints[result.startEdgeSection][i]);
            }
            result.points.push(result.endPoint);
        }


        result.polyline = new L.Polyline(result.points, {
            color: 'green',
            weight: 15,
            opacity: 0.5,
            smoothFactor: 1
        });
        result.polyline.addTo(mymap);
    }

    function addPointIfCan(point) {

        var findResult = MapHelper.findPosition(point, roadPoints, MapHelper.getZoom(mymap).coefficient);

        //Промазали сильно. TODO двигать точку пропорционально ближе к линии
        if (findResult.index == null) return;

        if (result.startPoint == null) {
            result.startPoint = point;
            result.startKm = findResult.distance + roadStart;
            result.startEdgeIndex = findResult.index;
            result.startEdgeSection = findResult.section;
        } else if (result.endPoint == null) {
            result.endPoint = point;
            result.endKm = findResult.distance + roadStart;
            result.endEdgeIndex = findResult.index;
            result.endEdgeSection = findResult.section;
        } else {
            return;
        }

        update();
    }

    function initPoint(foundPosition, location) {

        if (result.startPoint == null) {
            result.startPoint = foundPosition.point;
            result.startKm = location;
            result.startEdgeIndex = foundPosition.index;
            result.startEdgeSection = foundPosition.section;
        } else if (result.endPoint == null) {
            result.endPoint = foundPosition.point;
            result.endKm = location;
            result.endEdgeIndex = foundPosition.index;
            result.endEdgeSection = foundPosition.section;
        } else {
            return;
        }

        update();
    }

  return result;
};
